module.exports = __webpack_public_path__ + "core-img/success-bg.08bfbf84dab6dace5f6de49114ffbd17.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/images/debug-renderer/success-bg.png
// module id = 33
// module chunks = 0